<template>
  <div>
    <div class="box_right_tit">Contracts</div>
    <div class="chars_boxlist">
      <div class="charts">
        <div class="charts_tit">
          <div>Daily contract call</div>
          <div class="details">
            <span>Details</span> <img src="@/assets/pc/Index/more.png" />
          </div>
        </div>
        <div id="charts" ref="chartc" style="width: 406px; height: 290px"></div>
      </div>
      <div class="charts">
        <div class="charts_tit">
          <div>Daily Contract Call Distribution</div>
          <div class="details">
            <span>Details</span> <img src="@/assets/pc/Index/more.png" />
          </div>
         </div>
        <div
          id="charts"
          ref="chartc1"
          style="width: 406px; height: 290px"
        ></div>
      </div>
      <div class="charts">
        <div class="charts_tit">
          <div>Contract Count</div>
          <div class="details">
            <span>Details</span> <img src="@/assets/pc/Index/more.png" />
          </div>
        </div>
        <div
          id="charts"
          ref="chartc2"
          style="width: 406px; height: 290px"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import Homseach from "@/components/pc/serch.vue";

const echarts = require("echarts");
export default {
  data() {
    return {};
  },
  computed: {},
  watch: {
    // deep: true,
    $route: {
      handler: function (to) {
        console.log(to.query);
      },
      deep: true,
      immediate: true,
    },
  },
  components: {
    Homseach,
  },
  mounted() {
    this.initChartsc();
    this.initChartsc1();
    this.initChartsc2();
  },
  methods: {
    initChartsc() {
      this.lineChart = echarts.init(this.$refs.chartc);
      let option = {
        tooltip: {
          trigger: "axis",
        },
        // legend: {
        //   data: ["Email", "Union Ads", "Video Ads", "Direct", "Search Engine"],
        // },
        grid: {
          top: "9%",
          left: "3%",
          right: "4%",
          bottom: "8%",
          containLabel: true,
        },
        // toolbox: {
        //   feature: {
        //     saveAsImage: {},
        //   },
        // },
        xAxis: {
          type: "category",
          show: true,
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
          axisLine: {
            show: false, //隐藏x轴线
            lineStyle: {
              color: "#fff",
            },
          },
          axisTick: {
            show: false, //隐藏x轴刻度
          },
        },
        yAxis: {
          type: "value",
          show: true,
          axisLine: {
            show: false,
            lineStyle: {
              color: "#fff",
            },
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            type: "line",
            smooth: true, //是否平滑
            symbol: "circle",
            smooth: true, // 线条是否平滑
            showSymbol: false,
            symbolSize: 10,
            lineStyle: {
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {
                  offset: 1,
                  color: "#00E79A",
                },
                {
                  offset: 0,
                  color: "#00E79A",
                },
              ]), //线条渐变色
              shadowOffsetX: 1, // 折线的X偏移
              shadowOffsetY: 9, // 折线的Y偏移
              shadowBlur: 8, // 折线模糊
              shadowColor: "rgba(146, 169, 255, 100)", //折线颜色
            },
            itemStyle: {
              color: "#000",
              borderColor: "#AC43FC",
              borderWidth: 2,
              shadowColor: "rgba(0, 0, 0, .3)",
              shadowBlur: 0,
              shadowOffsetY: 2,
              shadowOffsetX: 2,
            },
            data: [8232, 932, 9231, 3234, 19230, 12330, 12320],
          },
        ],
      };
      this.lineChart.setOption(option);
    },
    initChartsc1() {
      this.lineChart = echarts.init(this.$refs.chartc1);
      var data = [
        { value: 1048, name: "USDT Token" },
        { value: 735, name: "LF8iBW9y1KL...pMszf" },
        { value: 580, name: "FTH-DC Token" },
        { value: 484, name: "DCT Token" },
        { value: 300, name: "LFdko4yMVrK...9D7iA" },
        { value: 300, name: "S-USDT-TRX Token" },
        { value: 300, name: "USDT Token" },
      ];

      let option = {
        tooltip: {
          trigger: "item",
        },
        graphic: [
          {
            type: "text",
            left: "42%",
            top: "32%",
            style: {
              text: "Total\n",
              textAlign: "center", //水平居中
              fill: "#91979D", //字体颜色
              width: 50,
              height: 30,
              font: '20px "STHeiti"', //字体大小
            },
          },
          {
            type: "text",
            left: "40%",
            top: "42%",
            style: {
              // text: '总数',
              text: data.reduce((n, i) => {
                return (n += i.value);
              }, 0),

              textAlign: "center",
              fill: "#fff",
              width: 30,
              height: 30,
              fontSize: 32,
            },
          },
          {
            type: "text",
            left: "42%",
            top: "54%",
            style: {
              text: "Calls\n",
              textAlign: "center", //水平居中
              fill: "#91979D", //字体颜色
              width: 50,
              height: 30,
              font: '20px "STHeiti"', //字体大小
            },
          },
        ],
        legend: {
          show: false,
          orient: "vertical",
          x: "40%", //可设定图例在左、右、居中
          y: "center",
          icon: "circle",
          padding: [0, 50, 0, 0],
          itemHeight: 6, // 图例icon高度
          itemWidth: 6, // 图例icon宽度
          align: "left", // 图例icon在左侧
          formatter: function (name) {
            // 添加
            let total = 0;
            let target;
            for (let i = 0; i < data.length; i++) {
              total += data[i].value;
              if (data[i].name === name) {
                target = data[i].value;
              }
            }
            var arr = [
              "{a|" + name + "}",

              "{c|" + target + " " + "calls" + "}",
              "{b|" + ((target / total) * 100).toFixed(2) + "%}",
            ];
            return arr.join("  ");
          },
          textStyle: {
            // 添加
            padding: [8, 0, 0, 0],
            rich: {
              a: {
                fontSize: 15,
                width: 180,
                color: "#fff",
              },
              b: {
                fontSize: 15,
                width: 80,
                color: "#c1c1c1",
              },
              c: {
                fontSize: 15,
                color: "#fff",
                width: 80,
              },
            },
          },
        },
        color: [
          "#00E79A",
          "#FFC302",
          "#A952FF",
          "#48D3E2",
          "#F76C9C",
          "#7C9FFC",
          "#9E3820",
        ],
        series: [
          {
            name: "Access From",
            type: "pie",
            radius: ["40%", "60%"],
            center: ["50%", "45%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            label: {
              normal: {
                show: true,
                position: "center",
                hoverAnimation: false,
                scale: false,
                textStyle: {
                  fontSize: 15,
                  color: "#00A870",
                  hoverAnimation: false,
                },
                emphasis: {
                  scale: false,
                  hoverAnimation: false,
                  label: {
                    show: false,
                    fontSize: "12",
                    fontWeight: "bold",
                  },
                },
              },
            },

            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: false,
                fontSize: 12,
                fontWeight: "bold",
              },
            },
            data: data,
          },
        ],
      };

      this.lineChart.setOption(option);
    },
    initChartsc2() {
      this.lineChart = echarts.init(this.$refs.chartc2);
      let option = {
        tooltip: {
          trigger: "axis",
        },
        // legend: {
        //   data: ["Email", "Union Ads", "Video Ads", "Direct", "Search Engine"],
        // },
        grid: {
          top: "9%",
          left: "3%",
          right: "4%",
          bottom: "8%",
          containLabel: true,
        },
        // toolbox: {
        //   feature: {
        //     saveAsImage: {},
        //   },
        // },
        xAxis: {
          type: "category",
          show: true,
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
          axisLine: {
            show: false, //隐藏x轴线
            lineStyle: {
              color: "#fff",
            },
          },
          axisTick: {
            show: false, //隐藏x轴刻度
          },
        },
        yAxis: {
          type: "value",
          show: true,
          axisLine: {
            show: false,
            lineStyle: {
              color: "#fff",
            },
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            type: "line",
            smooth: true, //是否平滑
            symbol: "circle",
            smooth: true, // 线条是否平滑
            showSymbol: false,
            symbolSize: 10,
            lineStyle: {
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {
                  offset: 1,
                  color: "#00E79A",
                },
                {
                  offset: 0,
                  color: "#00E79A",
                },
              ]), //线条渐变色
              shadowOffsetX: 1, // 折线的X偏移
              shadowOffsetY: 9, // 折线的Y偏移
              shadowBlur: 8, // 折线模糊
              shadowColor: "rgba(146, 169, 255, 100)", //折线颜色
            },
            itemStyle: {
              color: "#000",
              borderColor: "#00E79A",
              borderWidth: 2,
              shadowColor: "rgba(0, 0, 0, .3)",
              shadowBlur: 0,
              shadowOffsetY: 2,
              shadowOffsetX: 2,
            },
            data: [8232, 932, 9231, 3234, 19230, 12330, 12320],
          },
        ],
      };
      this.lineChart.setOption(option);
    },
  },
};
</script>

<style lang="less">
.box_right_tit {
  padding-top: 20px;
  margin-left: 20px;
  font-size: 18px;
  font-family: Source Han Sans CN-Medium, Source Han Sans CN;
  font-weight: 500;
  color: #ffffff;
}
.chars_boxlist {
  display: flex;
  flex-wrap: wrap;
  .charts_tit {
    padding-top: 20px;
    margin-left: 20px;
    font-size: 14px;
    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
    font-weight: 500;
    color: #ffffff;
  }
  .charts {
    width: 406px;
    height: 326px;
    background: #0b0c0f;
    border-radius: 16px 16px 16px 16px;
    opacity: 1;
    margin-top: 20px;
    margin-left: 20px;
  }
}
</style>
